export const DOWNLOAD_PDF = 'legal/DOWNLOAD_PDF'

// downloadPDF :: String -> Action
export const downloadPDF = filename => ({
    type: DOWNLOAD_PDF,
    filename,
})
